(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  /**
   * Rotates the announcement messages. Everything here is an enhancement:
   * the markup already shows all of them.
   */
  (() => {
    const bar = document.querySelector('[data-announce]');
    if (!bar) return;

    const items = [...bar.querySelectorAll('[data-announce-item]')];
    if (items.length < 2) return;

    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (calm.matches) return;

    const interval = Number(bar.dataset.announceInterval) || 4000;
    let index = 0;

    bar.classList.add('announce--rotating');
    items[0].setAttribute('data-active', '');

    setInterval(() => {
      items[index].removeAttribute('data-active');
      index = (index + 1) % items.length;
      items[index].setAttribute('data-active', '');
    }, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Enhancement only. The form and gallery both work without this file.
  class ProductPage {
    constructor(root) {
      this.root = root;
      this.priceDisplay = root.querySelector('[data-price-display]');
      this.atc = root.querySelector('[data-atc]');
      this.inputs = root.querySelectorAll('.pack__input');

      this.inputs.forEach((input) =>
        input.addEventListener('change', () => this.onVariantChange(input))
      );

      this.gallery = root.querySelector('[data-gallery]');
      this.setupPicker(root);

      this.sticky = root.querySelector('[data-sticky-atc]');
      this.stickyPrice = root.querySelector('[data-sticky-price]');
      root
        .querySelector('[data-sticky-add]')
        ?.addEventListener('click', () => this.atc?.click());

      this.galleryCount = root.querySelector('[data-gallery-count]');

      this.offer = root.querySelector('[data-offer]');
      if (this.offer) {
        this.money = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.offer.dataset.currency,
        });
      }

      this.observeGallery();
      this.observeAtc();
    }

    observeAtc() {
      if (!this.sticky || !this.atc) return;

      // Show the bar only once the real button is out of view above.
      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.sticky.classList.toggle('is-visible', scrolledPast);
        },
        { threshold: 0 }
      );

      observer.observe(this.atc);
    }

    /* ---------- Variant picker ---------- */

    setupPicker(root) {
      this.picker = root.querySelector('[data-picker]');
      if (!this.picker) return;

      this.select = this.picker.querySelector('[data-variant-select]');
      try {
        this.variants = JSON.parse(
          this.picker.querySelector('[data-variant-data]').textContent
        );
      } catch (error) {
        // Leave the select as the working control rather than break the form.
        console.error('Variant data could not be parsed', error);
        return;
      }

      const groups = [...this.picker.querySelectorAll('.picker__group')];
      this.colorIndex = groups.findIndex((group) =>
        ['color', 'colour'].includes(group.dataset.optionName)
      );

      this.picker
        .querySelectorAll('.opt__input')
        .forEach((input) =>
          input.addEventListener('change', () => this.onOptionChange())
        );

      this.refreshAvailability();
    }

    /** Option values currently checked, in option order. */
    selectedOptions() {
      const groups = [...this.picker.querySelectorAll('.picker__group')];
      return groups.map((group) => {
        const checked = group.querySelector('.opt__input:checked');
        return checked ? checked.value : null;
      });
    }

    matchVariant(options) {
      return this.variants.find((variant) =>
        options.every((value, i) => value === null || variant.options[i] === value)
      );
    }

    onOptionChange() {
      const chosen = this.selectedOptions();
      const variant = this.matchVariant(chosen);

      this.refreshAvailability();

      // Label beside each legend.
      this.picker.querySelectorAll('[data-chosen-for]').forEach((el, i) => {
        el.textContent = chosen[i] || '';
      });

      if (!variant) {
        if (this.atc) this.atc.disabled = true;
        return;
      }

      if (this.select) {
        this.select.value = String(variant.id);
      }

      if (this.atc) {
        this.atc.disabled = !variant.available;
        this.atc.textContent = variant.available
          ? this.atc.dataset.labelAdd
          : this.atc.dataset.labelSoldOut;
      }

      this.renderPrice(variant);

      if (this.colorIndex > -1) {
        this.filterGalleryByColor(chosen[this.colorIndex]);
      } else {
        this.showVariantMedia(variant);
      }

      // Keep the URL shareable without adding a history entry per click.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    renderPrice(variant) {
      const current = this.priceDisplay?.querySelector('.pdp__price-current');
      if (current) current.textContent = variant.price;
      if (this.stickyPrice) this.stickyPrice.textContent = variant.price;

      const was = this.priceDisplay?.querySelector('.pdp__price-was');
      const save = this.priceDisplay?.querySelector('.pdp__price-save');
      const discounted = variant.compareRaw > variant.priceRaw;
      if (was) was.hidden = !discounted;
      if (save) save.hidden = !discounted;
      if (discounted && was) {
        was.lastChild.textContent = ' ' + variant.compare;
      }

      this.renderOffer(variant.priceRaw);
    }

    /** Recalculate each quantity tier from the chosen variant's price. */
    renderOffer(priceCents) {
      if (!this.offer || typeof priceCents !== 'number') return;
      const format = (cents) => this.money.format(cents / 100);

      this.offer.querySelectorAll('[data-offer-qty]').forEach((input) => {
        const qty = Number(input.dataset.offerQty);
        // A per-product tier price is a fixed total, so it does not move with
        // the chosen variant; everything else is quantity times variant price.
        // A fixed total does not move with the variant. An amount off and a
        // number of free units both do, which is what a product with two
        // prices needs — without this the tier kept its server-rendered
        // price and a variant change quietly showed the wrong number.
        const fixed = input.dataset.offerFixed;
        const off = Number(input.dataset.offerOff || 0);
        const free = Number(input.dataset.offerFree || 0);
        let total;
        if (fixed) {
          total = Number(fixed);
        } else if (free) {
          total = priceCents * Math.max(qty - free, 0);
        } else {
          total = Math.max(priceCents * qty - off, 0);
        }
        const tier = input.closest('.pack');

        const totalEl = tier.querySelector('[data-offer-total]');
        if (totalEl) totalEl.textContent = format(total);

        const fullEl = tier.querySelector('[data-offer-full]');
        if (fullEl) fullEl.textContent = format(priceCents * qty);
        if (fullEl) fullEl.closest('.offer__was').hidden = total >= priceCents * qty;

        const unitEl = tier.querySelector('[data-offer-unit]');
        if (unitEl) {
          unitEl.textContent = unitEl.dataset.template.replace(
            '%PRICE%',
            format(Math.floor(total / qty))
          );
        }
      });
    }

    /**
     * Show only the images belonging to the chosen colour, plus the ones with
     * no colour of their own — the feature graphics and heating diagrams,
     * which apply whichever colour you pick.
     */
    filterGalleryByColor(color) {
      if (!this.gallery || !color) return;
      if (this.gallery.dataset.currentColor === color) return;
      this.gallery.dataset.currentColor = color;

      const first = String(color).split(' ')[0];
      const matches = (el) => {
        const own = el.dataset.mediaColor || '';
        return own === '' || own === color || own === first;
      };

      this.gallery
        .querySelectorAll('.gallery__slide')
        .forEach((slide) => { slide.hidden = !matches(slide); });

      this.gallery
        .querySelectorAll('.gallery__thumbs > li')
        .forEach((item) => { item.hidden = !matches(item); });

      // Jump to the first image of the new colour so the change is visible.
      const lead = this.gallery.querySelector('.gallery__slide:not([hidden])');
      if (lead) {
        lead.scrollIntoView({ block: 'nearest', inline: 'start' });
        this.updateCounter(lead);
      }
    }

    /** Counter reflects the images actually on screen, not the whole set. */
    updateCounter(slide) {
      if (!this.galleryCount) return;
      const visible = [
        ...this.root.querySelectorAll('.gallery__slide:not([hidden])'),
      ];
      const index = visible.indexOf(slide) + 1;
      if (index < 1) return;
      const template = this.galleryCount.dataset.countTemplate || '%i% / %n%';
      this.galleryCount.textContent = template
        .replace('%i%', index)
        .replace('%n%', visible.length);
    }

    showVariantMedia(variant) {
      if (!variant.mediaId) return;
      const slide = this.root.querySelector('#media-' + variant.mediaId);
      if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start' });
    }

    /**
     * Recompute which values are purchasable given the current selection.
     * Liquid renders this correctly on load, but once the customer starts
     * clicking it has to be maintained here.
     */
    refreshAvailability() {
      const chosen = this.selectedOptions();
      const groups = [...this.picker.querySelectorAll('.picker__group')];

      groups.forEach((group, position) => {
        group.querySelectorAll('.opt__input').forEach((input) => {
          const probe = chosen.slice();
          probe[position] = input.value;
          // Only constrain by options before this one, matching how Shopify
          // resolves availability server-side.
          for (let i = position + 1; i < probe.length; i += 1) probe[i] = null;

          const reachable = this.variants.some(
            (variant) =>
              variant.available &&
              probe.every((v, i) => v === null || variant.options[i] === v)
          );

          input.dataset.unavailable = reachable ? 'false' : 'true';
          input.nextElementSibling?.classList.toggle('opt__label--out', !reachable);
        });
      });
    }

    onVariantChange(input) {
      const available = input.dataset.available === 'true';
      if (this.atc) {
        this.atc.disabled = !available;
      }

      // The chosen pack's price is already rendered in its own label, so we
      // mirror it rather than recompute and risk showing a different number.
      const label = input.closest('.pack');
      const price = label?.querySelector('.pack__price')?.textContent?.trim();
      const current = this.priceDisplay?.querySelector('.pdp__price-current');
      if (price && current) {
        current.textContent = price;
      }
      if (price && this.stickyPrice) {
        this.stickyPrice.textContent = price;
      }
    }

    observeGallery() {
      const slides = this.root.querySelectorAll('.gallery__slide');
      const thumbs = this.root.querySelectorAll('.gallery__thumb');
      if (!slides.length || !thumbs.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.id.replace('media-', '');
            thumbs.forEach((thumb) =>
              thumb.classList.toggle('is-active', thumb.dataset.thumb === id)
            );

            this.updateCounter(entry.target);
          });
        },
        { threshold: 0.6 }
      );

      slides.forEach((slide) => observer.observe(slide));
    }
  }

  document.querySelectorAll('[data-pdp]').forEach((el) => new ProductPage(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-track]');
      this.slides = [...root.querySelectorAll('[data-slide]')];
      this.dots = [...root.querySelectorAll('[data-dot]')];
      this.pauseButton = root.querySelector('[data-pause]');
      this.index = 0;
      this.userPaused = false;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollBehavior = reduced ? 'auto' : 'smooth';
      this.autoplay = root.dataset.autoplay === 'true' && !reduced && this.slides.length > 1;
      this.interval = Number(root.dataset.interval) || 6000;

      const controls = root.querySelector('[data-controls]');
      if (controls) controls.hidden = false;
      if (this.pauseButton && !this.autoplay) this.pauseButton.hidden = true;

      root.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      root.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
      this.pauseButton?.addEventListener('click', () => this.togglePause());

      // Pause while someone is reading or interacting, resume after.
      ['mouseenter', 'focusin', 'touchstart'].forEach((type) =>
        root.addEventListener(type, () => this.stop(), { passive: true })
      );
      ['mouseleave', 'focusout'].forEach((type) =>
        root.addEventListener(type, () => this.start())
      );
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.stop() : this.start()
      );

      this.observe();
      this.start();
    }

    /** Track which slide is on screen, whether it got there by swipe or button. */
    observe() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setCurrent(this.slides.indexOf(entry.target));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => observer.observe(slide));
    }

    setCurrent(index) {
      this.index = index;
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      // Only the visible slide's visible video plays; the rest cost nothing.
      this.slides.forEach((slide, i) => {
        slide.querySelectorAll('video').forEach((video) => {
          const shown = i === index && video.offsetParent !== null;
          if (shown) video.play().catch(() => {});
          else video.pause();
        });
      });
    }

    go(index) {
      const count = this.slides.length;
      const next = (index + count) % count;
      this.track.scrollTo({ left: this.slides[next].offsetLeft, behavior: this.scrollBehavior });
    }

    start() {
      if (!this.autoplay || this.userPaused || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    togglePause() {
      this.userPaused = !this.userPaused;
      const button = this.pauseButton;
      button.setAttribute('aria-pressed', String(this.userPaused));
      button.setAttribute(
        'aria-label',
        this.userPaused ? button.dataset.labelPlay : button.dataset.labelPause
      );
      if (this.userPaused) this.stop();
      else this.start();
    }
  }

  document.querySelectorAll('[data-slideshow]').forEach((root) => new Slideshow(root));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-slideshow]').forEach((root) => new Slideshow(root));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-row"] && !Shopify.designMode) return;
  try {
    
  /**
   * Upgrades the clips from "tap to play" to "plays while you look at it".
   * Everything here is an enhancement: the markup already works.
   */
  (() => {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (calm.matches || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-video-row]').forEach((row) => {
      const videos = [...row.querySelectorAll('video')];
      if (!videos.length) return;

      // The card is a link, so the clip carries no controls: a control bar
      // inside a link means tapping play navigates instead. Muted again here
      // because autoplay is refused otherwise.
      videos.forEach((video) => {
        video.controls = false;
        video.muted = true;
      });

      const watcher = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              // preload="none" means there is nothing to play yet.
              if (video.preload === 'none') video.preload = 'auto';
              // Autoplay refused: the poster frame stays, which is a
              // perfectly good still of the product, and the card still
              // links through. Nothing to hand back to the viewer.
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );

      videos.forEach((video) => watcher.observe(video));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
